import { toast } from "react-toastify";

const useToast = () => {
  return { toast };
};

export default useToast;
